import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { prefersReducedMotion } from '@/lib/motion';

// Лёгкий fade+translate при смене маршрута.
// Сознательно короткий (~160ms) — задача переход подсказать, а не задерживать.
export function RouteTransition({ children, className }) {
  const location = useLocation();
  const [phase, setPhase] = useState('in');
  const [renderKey, setRenderKey] = useState(location.pathname);
  const pendingChildren = useRef(children);

  useEffect(() => {
    if (prefersReducedMotion()) {
      setRenderKey(location.pathname);
      pendingChildren.current = children;
      setPhase('in');
      return;
    }
    if (renderKey === location.pathname) {
      pendingChildren.current = children;
      return;
    }
    setPhase('out');
    const timer = setTimeout(() => {
      pendingChildren.current = children;
      setRenderKey(location.pathname);
      // Re-render под новым ключом и плавно входим
      requestAnimationFrame(() => setPhase('in'));
    }, 160);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Контент мог обновиться без смены url (повторный рендер, Suspense).
  // Тогда просто синхронизируем subtree, без видимого перехода.
  useEffect(() => {
    if (renderKey === location.pathname) {
      pendingChildren.current = children;
    }
  }, [children, renderKey, location.pathname]);

  return (
    <div
      className={cn(
        'route-transition',
        phase === 'out' ? 'route-transition--out' : 'route-transition--in',
        className
      )}
      data-route-key={renderKey}
    >
      {pendingChildren.current}
    </div>
  );
}

export default RouteTransition;
